import { render } from "./eyerweb.vue?vue&type=template&id=48e3c25c&scoped=true"
import script from "./eyerweb.vue?vue&type=script&lang=js"
export * from "./eyerweb.vue?vue&type=script&lang=js"

import "./eyerweb.vue?vue&type=style&index=0&id=48e3c25c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e3c25c"]])

export default __exports__